<template>
  <div class="row">
    <div class="col-lg">
      <h2>Add Employee</h2>
    </div>
    <div class="col-md-12">
      <div class="col-lg-12 text-center">
        <h2>Please fill in the form below</h2>
      </div>

      <card class="stacked-form">
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-4 ml-auto mr-auto">
              <h3 style="border-bottom: solid red">Employee Management</h3>
              <base-input label="Name" v-model="Name" placeholder="Name"></base-input>
              <base-input label="Employee ID" v-model="EmployeeID" placeholder="Employee ID"></base-input>
              <base-input label="Department" placeholder="Department">
                <el-select class="select-success" filterable placeholder="Department" v-model="Department">
                    <el-option
                    v-for="region in selects.department"
                    class="select-success"
                    :value="region.value"
                    :label="region.label"
                    :key="region.label"
                    >
                    </el-option>
                </el-select>
              </base-input>
              <base-input label="Designation">
                <el-autocomplete  
                  class="inline-input"
                  v-model="Designation" 
                  :fetch-suggestions="designationSearch"
                  placeholder="Designation"
                  >
                </el-autocomplete>
              </base-input>
              <base-input label="Reported To">
                <el-select class="select-success" filterable placeholder="Reported To" v-model="ReportedTo">
                    <el-option
                    v-for="region in selects.reportedto"
                    class="select-success"
                    :value="region.value"
                    :label="region.label"
                    :key="region.label"
                    >
                    </el-option>
                </el-select>
                <!-- <el-autocomplete  
                  class="inline-input"
                  v-model="ReportedTo" 
                  :fetch-suggestions="querySearch"
                  placeholder="Reported To"
                  :trigger-on-focus="false"
                  >
                </el-autocomplete> -->
              </base-input>
            </div>
            <div class="col-md-4 ml-auto mr-auto">
              <h3></h3>
              <base-input label="Service Area" v-model="ServiceArea">
                <el-select class="select-success" filterable placeholder="Service Area" v-model="ServiceArea">
                    <el-option
                    v-for="region in selects.servicearea"
                    class="select-success"
                    :value="region.value"
                    :label="region.label"
                    :key="region.label"
                    >
                    </el-option>
                </el-select>
              </base-input>
              <base-input label="Work Location" >
                <el-select class="select-success" filterable placeholder="Work Location" v-model="WorkLocation">
                    <el-option
                    v-for="worklocation in selects.worklocation"
                    class="select-success"
                    :value="worklocation.value"
                    :label="worklocation.label"
                    :key="worklocation.label"
                    >
                    </el-option>
                </el-select>
              </base-input>
              <!-- <base-input label="Latitude" v-model="Latitude" placeholder="Latitude"></base-input>
              <base-input label="Longitude" v-model="Longitude" placeholder="Longitude"></base-input> -->
            </div>
          </div>
        </form>
      </card>
      <div class="col-lg-12 text-center">
        <el-link href="./img/csv/EmployeeRegistration.csv" class="mt-3" type="primary">Download CSV template</el-link>
        &nbsp;
        <base-button 
          @click="modalsCSV = true"
          class="mt-3"
          native-type="submit"
          type="green"
          simple
        >Import with CSV</base-button>&nbsp;
        <base-button
          class="mt-3"
          native-type="submit"
          type="primary"
          @click="addEmployee()"
          >Submit</base-button>
      </div>
       <!-- modal -->
      <modal :show.sync="modalsCSV" footer-classes="justify-content-center" type="notice">
        <h3 slot="header" class="modal-title">Import CSV Form</h3>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12 text-center">
              <label id="fileName">{{ fileName }}</label>
              <span class="btn btn-info btn-file">
                <span class="fileinput-new">Choose File</span>
                <input
                  accept=".csv"
                  type="file"
                  class="valid"
                  :multiple="false"
                  @change="readFile"
                />
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-center spinner" v-if="load">
            <circle-8></circle-8>
          </div>
        </div>
        <template slot="footer">
          <!--  -->
          <base-button
            @click="send()"
            :disabled="disabledsend"
            class="mt-3"
            native-type="submit"
            type="success"
          >Submit</base-button>&nbsp;&nbsp;&nbsp;
          <base-button class="mt-3" type="danger" @click.native="modalsCSV = false">Cancel</base-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import { BaseCheckbox, BaseRadio } from "src/components/index";
import { Select, Option, Autocomplete, Link } from "element-ui";
import { touches } from "d3";
import swal from "sweetalert2";
import { Modal } from "src/components/index";
import { Circle8 } from "vue-loading-spinner";

export default {
  components: {
    BaseCheckbox,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio,
    [Autocomplete.name]: Autocomplete,
    Modal,
    Circle8,
    [Link.name]: Link
  },
  data() {
    return {
        csv: "../assets/csv/Employee Registration.csv",
        load: false,
        disabledsend: true,
        selects: {
          servicearea: [],
          department: [],
          reportedto: [],
          worklocation: []
        },
        designation: [],
        Name: "",
        EmployeeID: "",
        Department: "",
        Designation: "",
        ReportedTo: "",
        ServiceArea: "",
        WorkLocation: "",
        Latitude: "",
        Longitude: "",
        status: "",
        // import csv
        modalsCSV: false,
        disabled: true,
        fileName: "",
        designation_1: [],
        reportedto_1: [],
        datacsv: []
    };
  },
  mounted() {
  },
  created(){
    this.getServiceArea();
    this.getDepartment();
    this.getReportedTo();
    this.getDesignation();
    this.getWorkLocation();
  },
  methods: {
    readFile(ev){
      this.datacsv = [];
      let temp = []
      const file = ev.target.files[0];
      const reader = new FileReader();
      reader.readAsText(file);
      this.fileName = file.name
      reader.onload = e => {
        let header;
        let lines = [];
        let csv = e.target.result;
        let allTextLines = csv.split(/\r\n|\n/);
        for(var i=0; i<allTextLines.length; i++){
          if(i == 0){
            header = allTextLines[i].split(",");
          } else {
            lines.push(allTextLines[i].split(","));
          }
        }
        lines.pop();
        
        // console.log("header", header)
        // console.log(header[0])
        
        // check header name 
        if( header[0] !== "Name" || header[1] !== "EmployeeID" || header[2] !== "Department" || header[3] !== "Designation" || header[4] !== "Reported To" || header[5] !== "Service Area" || header[6] !== "Work Location"){
          let img = "@/assets/img/absent.png" 
          swal({
            title: "Header Error!",
            html: '<b>Make sure you follow the predefined header as below:</b><img width="100%" height="100%" src="img/attendace - employeemgmt.PNG">',
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false
          })
        } else {
          let keysubmit = 0
          // console.log("lines", lines)
          lines.forEach(line => {
            // console.log(line[1])

            // find  status id
            if(line[0] == "" || line[1] == "" || line[2] == "" || line[3] == "" || line[4] == ""){
              swal({
                title: "Data Error!",
                text: "All data must be filled!",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false
              });
            } else {
              console.log("#############start read csv######################")
              // check department
              let departmentstatus = 1
              let department = ""
              console.log(line[2])
              for(var i=0; i<this.selects.department.length; i++){
                console.log(this.selects.department[i].label)
                if(line[2] == this.selects.department[i].label){
                  this.disabled = true
                  departmentstatus = 0
                  department = this.selects.department[i].value
                  break;
                } 
              }

              if(department == ""){
                departmentstatus = 1
                swal({
                  title: "Data Error!",
                  text: "Department " + line[2] + " for employee name " + line[0] + " does not exist! Please register department in Setting > General > Department.",
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false
                });
              }

              // // check designation
              // let designationstatus = 1
              // console.log(line[3])
              // for(var i=0; i<this.designation_1.length; i++){
              //   console.log(this.designation_1[i])
              //   if(line[3] == this.designation_1[i]){
              //     this.disabled = true
              //     designationstatus = 0
              //   break;
              //   } 
              // }

              // if(designationstatus == 1){
              //   swal({
              //     title: "Data Error!",
              //     text: "Designation " + line[3] + " registered for employee name " + line[0] + " does not exist!",
              //     type: "warning",
              //     confirmButtonClass: "btn btn-success btn-fill",
              //     confirmButtonText: "Okay",
              //     buttonsStyling: false
              //   });
                
              // }

              // check service area
              let serviceareastatus = 1
              let serviceareaid = ""
              for(var i=0; i<this.selects.servicearea.length; i++){
                if(line[5] == this.selects.servicearea[i].label){
                  this.disabled = true
                  serviceareastatus = 0
                  serviceareaid = this.selects.servicearea[i].value
                  break;
                } 
              }

              if(serviceareaid == ""){
                console.log("service area not exist!")
                swal({
                  title: "Data Error!",
                  text: "Service Area " + line[5] + " for employee name " + line[0] + " does not exist! Please register service area in Setting > Attendance > Service Area.",
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false
                });
              }

              // check reported to
              let reportedtostatus = 1
              console.log(line[4])
              console.log(this.selects.reportedto)
              for(var i=0; i<this.selects.reportedto.length; i++){
                if(line[4] == this.selects.reportedto[i].value){
                  this.disabled = true
                  reportedtostatus = 0
                  break;
                } 
              }

              if(reportedtostatus == 1){
                swal({
                  title: "Data Error!",
                  text: "Reporting manager/superior " + line[4] + " for employee name " + line[0] + " is not registered! Please register manager/superior in Employee Management page.",
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false
                });
                
              }

              // check work location
              let worklocationid = ""
              let worklocationstatus = 1
              
              console.log(this.selects.worklocation)
              for(var i=0; i<this.selects.worklocation.length; i++){
                // console.log(this.selects.worklocation[i].label)
                if(line[6] == this.selects.worklocation[i].label){
                  this.disabled = true
                  worklocationstatus = 0
                  // console.log("work location wujud")
                  worklocationid = this.selects.worklocation[i].value
                  break;
                } 
              }

              if(worklocationid == ""){
                worklocationstatus = 1
                // console.log("hai aku bava else")
                swal({
                  title: "Data Error!",
                  text: "Work Location " + line[6] + " for employee name " + line[0] + " does not exist! Please register work location in Setting > Attendance > Service Location.",
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false
                });
              }
              if( departmentstatus == 0  && reportedtostatus == 0 && serviceareastatus == 0 && worklocationstatus == 0){
                keysubmit = 1
                let payload = {
                  Name: line[0],
                  EmpID: line[1],
                  Department: department,
                  Position: line[3],
                  ReportedTo: line[4],
                  ServiceAreaID: serviceareaid,
                  WorkLocationID: worklocationid
                }
                console.log(payload)
                temp.push(payload)
              }
              
            }
          })
          console.log(temp)
          if(keysubmit == 1){
            console.log("hanter")
            this.disabledsend = false
            this.datacsv = temp
            // this.send(temp)
          }
          
        }
      }
    },
    getWorkLocation(){
      this.$http.get(":9995/api/v1/manage/location")
        .then(res =>{
          let response = res.message
          console.log(response)
          for(var i=0; i<response.length; i++){
            let obj = {
              label: response[i].LocationName,
              value: response[i].WorkLocationID
            }
            this.selects.worklocation.push(obj)
          }
        })
    },
    getDesignation(){
      let Designation = []
      this.$http.get(":9995/api/v1/manage/employee")
        .then(res =>{
          let response = res.message
          console.log(response)
          
          for(var i=0; i<response.length; i++){
            Designation.push(response[i].Position)
            
          }

          let temp = []
          for(var i=0; i<Designation.length; i++){
            if(temp.indexOf(Designation[i]) === -1){
              temp.push(Designation[i])
              this.designation_1.push(Designation[i])
            }
          }

          // console.log(temp)

          for(var i=0; i<temp.length; i++){
            let obj = {
              value: temp[i],
              label: temp[i]
            }
            this.designation.push(obj)
          }
        })
    },
    designationSearch(queryDesignation, cb){
      var links = this.designation;
      console.log(links)
        var results = queryDesignation ? links.filter(this.createDesignation(queryDesignation)) : links;
        // call callback function to return suggestions
        cb(results);
    },
    createDesignation(queryDesignation) {
      
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryDesignation.toLowerCase()) === 0);
        };
    },
    querySearch(queryString, cb) {
        var links = this.selects.reportedto;
        console.log(links)
        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
        // call callback function to return suggestions
        cb(results);
    },
    createFilter(queryString) {
      console.log(queryString)
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
    },
    getReportedTo(){
      this.selects.reportedto = []
      this.$http.get(":9995/api/v1/manage/reportedto")
        .then(res=>{
          if(!res.error){
            let response = res.message
            console.log(response)
            // let filter = []
            // for(var i=0; i<response.length; i++){
            //   filter.push(response[i].ReportedTo)
              
            // }

            // let temp = []
            // for(var i=0; i<filter.length; i++){
            //   if(temp.indexOf(filter[i]) == -1){
            //     temp.push(filter[i])
            //     this.reportedto_1.push(filter[i])
            //   }
            // }

            // for(var i=0; i<temp.length; i++){
            //   let obj = {
            //     label: temp[i],
            //     value: temp[i]
            //   }
            //   this.selects.reportedto.push(obj)
            // }
            for(var i=0; i<response.length; i++){
              let obj = {
                label: response[i].Name,
                value: response[i].EmpID
              }
              this.selects.reportedto.push(obj)
            }
          }
        })
    },
    getDepartment(){
      this.selects.department = []
      this.$http.get(":9995/api/v1/manage/department")
        .then(res=>{
          if(!res.error){
            let response = res.message
            console.log(response)
            for(var i=0; i<response.length; i++){
              let obj = {
                label: response[i].DeptName,
                value: response[i].DeptID
              }
              this.selects.department.push(obj)
            }
          }
        })
    },
    getServiceArea(){
      this.selects.servicearea = []
      this.$http.get(":9995/api/v1/manage/area")
        .then(res => {
          let response = res.message
          console.log(response)

          for(var i=0; i<response.length; i++){
            console.log(response[i].ServiceAreaName)
            let obj = {
              value: response[i].ServiceAreaID,
              label: response[i].ServiceAreaName
            }
            this.selects.servicearea.push(obj)
          }
        })
    },
    addEmployee(){
      let arr = []
      this.datacsv = []
      if(this.Name === "" || this.WorkLocation === "" || this.EmployeeID === "" || this.Department === "" || this.Designation === "" || this.ReportedTo === "" ){
        swal({
          type: "error",
          title: "Oops... form cannot be empty!"
        });
      } else{
        // send
        let payload = {
          EmpID: this.EmployeeID,
          Name: this.Name,
          ReportedTo: this.ReportedTo,
          Department: this.Department,
          Position: this.Designation,
          ReportedTo: this.ReportedTo,
          WorkLocationID: this.WorkLocation,
          ServiceAreaID: this.ServiceArea,
          // Latitude: parseFloat(this.Latitude),
          // Longitude: parseFloat(this.Longitude),
          IsActive: "1"
        }
        console.log(payload)
        arr.push(payload)
        this.datacsv.push(payload)
        this.send()
        
      }
    },
    send(){
      this.load = true
      console.log(this.datacsv)
      // send
      this.$http.post(":9995/api/v1/manage/employee", this.datacsv)
        .then(res=> {
            if(!res.error){
              let data = res.message
              swal({
                title: "Successful!",
                text: res.message,
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false
              });
              this.modals2 = false
              this.$router.push("/attendance/EmployeeManagement");
              this.Name = ""
              this.EmployeeID = ""
              this.Department = ""
              this.Designation = ""
              this.ReportedTo = ""
              this.WorkLocation = ""
              this.Latitude = ""
              this.Longitude = ""
            } else {
              swal({
                title: "Data Error!",
                text: `${res.message}`,
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false
              });
            }
            this.load = false
            this.disabledsend = false
          })
      
    }
  }
};
</script>
<style lang="scss">
.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.inline-input{
  width: 100%;
}
</style>
